
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {
  Layout,
  Padding,
  Content,
  Position,
  Title,
  Text,
  TextLink,
  Margin,
  Size,
  Input,
  FormGroup,
  Label,
  ButtonLink,
  Button,
  Category,
  Tier,
  AnimatedItem,
  AnimationGroup,
  Direction,
  Speed,
} from '@drawbotics/react-drylus';
import { css } from '@emotion/css';
import { Navigate, Route, Link, MemoryRouter, Routes, useLocation } from 'react-router-dom';
import Playground from '~/components/Playground';
import { Navbar } from './components/Navbar';
import page1 from '~/assets/page-1.png';
import page2 from '~/assets/page-2.png';
export const styles = {
  leftSplit: css`
    width: 450px;
    min-height: 600px;
  `,
  wrapper: css`
    position: relative;
    overflow: hidden;
    height: 100%;
  `,
  image: css`
    position: absolute;
    top: 70px;
    right: -100px;
    width: calc(100% + 50px);
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  `,
  center: css`
    display: flex;
    flex-direction: column;
    align-items: center;
  `
};
export const BaseLayout = ({
  content,
  image
}) => {
  return <Layout position={Position.LEFT} bar={<div className={styles.leftSplit}>
          <Padding size={Size.EXTRA_LARGE} mdxType="Padding">
            {content}
          </Padding>
        </div>} mdxType="Layout">
      <Content fullWidth fullHeight mdxType="Content">
        <div className={styles.wrapper}>
          <div className={styles.image}>
            {image}
          </div>
        </div>
      </Content>
    </Layout>;
};
export const AnimatedRoutes = () => {
  const location = useLocation();
  return <AnimationGroup animateExit mdxType="AnimationGroup">
      <Routes location={location} key={location.pathname} mdxType="Routes">
        <Route path="/1" element={<BaseLayout content={<AnimationGroup speed={Speed.FAST} staggerChildren direction={Direction.TOP_DOWN} mdxType="AnimationGroup">
                <AnimatedItem animateExit mdxType="AnimatedItem">
                  <Title mdxType="Title">Sign in</Title>
                </AnimatedItem>
                <AnimatedItem animateExit mdxType="AnimatedItem">
                  <Text mdxType="Text">Need an account? <TextLink mdxType="TextLink">Sign up now</TextLink></Text>
                </AnimatedItem>
                <Margin size={{
          bottom: Size.EXTRA_HUGE
        }} mdxType="Margin" />
                <AnimatedItem animateExit mdxType="AnimatedItem">
                  <FormGroup input={<Input value="" placeholder="your-email@gmail.com" onChange={() => {}} mdxType="Input" />} label={<Label mdxType="Label">Email address</Label>} mdxType="FormGroup" />
                  <Margin size={{
            bottom: Size.DEFAULT
          }} mdxType="Margin" />
                  <FormGroup input={<Input type="password" value="mysupersecurepassword" onChange={() => {}} mdxType="Input" />} label={<Label mdxType="Label">Password</Label>} mdxType="FormGroup" />
                  <Margin size={{
            bottom: Size.SMALL
          }} mdxType="Margin" />
                  <TextLink mdxType="TextLink">Forgot your password?</TextLink>
                </AnimatedItem>
                <Margin size={{
          bottom: Size.LARGE
        }} mdxType="Margin" />
                <AnimatedItem animateExit mdxType="AnimatedItem">
                  <Link to="/2" mdxType="Link">
                    <ButtonLink category={Category.BRAND} mdxType="ButtonLink">Sign in</ButtonLink>
                  </Link>
                </AnimatedItem>
                <AnimatedItem animateExit mdxType="AnimatedItem">
                  <Margin size={{
            bottom: Size.LARGE
          }} mdxType="Margin" />
                </AnimatedItem>
              </AnimationGroup>} image={<AnimatedItem speed={Speed.SLOW} direction={Direction.RIGHT_LEFT} animateExit mdxType="AnimatedItem">
                <img src={page1} />
              </AnimatedItem>} mdxType="BaseLayout" />} mdxType="Route" />
        <Route path="/2" element={<BaseLayout content={<div className={styles.center}>
                <AnimationGroup speed={Speed.FAST} staggerChildren direction={Direction.TOP_DOWN} mdxType="AnimationGroup">
                  <AnimatedItem animateExit mdxType="AnimatedItem">
                    <Title mdxType="Title">All done!</Title>
                  </AnimatedItem>
                  <Margin size={{
            bottom: Size.DEFAULT
          }} mdxType="Margin" />
                  <AnimatedItem animateExit mdxType="AnimatedItem">
                    <Text mdxType="Text">You're almost done!</Text>
                    <Margin size={{
              bottom: Size.EXTRA_SMALL
            }} mdxType="Margin" />
                    <Text mdxType="Text">Check your emails to validate your account</Text>
                  </AnimatedItem>
                  <Margin size={{
            bottom: Size.LARGE
          }} mdxType="Margin" />
                  <AnimatedItem animateExit mdxType="AnimatedItem">
                    <Button tier={Tier.SECONDARY} mdxType="Button">I've already confirmed it</Button>
                  </AnimatedItem>
                  <Margin size={{
            bottom: Size.LARGE
          }} mdxType="Margin" />
                  <AnimatedItem animateExit mdxType="AnimatedItem">
                    <Link to="/1" mdxType="Link">
                      <TextLink mdxType="TextLink">Back to previous</TextLink>
                    </Link>
                  </AnimatedItem>
                  <Margin size={{
            bottom: Size.LARGE
          }} mdxType="Margin" />
                </AnimationGroup>
              </div>} image={<AnimatedItem speed={Speed.SLOW} direction={Direction.RIGHT_LEFT} animateExit mdxType="AnimatedItem">
                <img src={page2} />
              </AnimatedItem>} mdxType="BaseLayout" />} mdxType="Route" />
        <Route path="/" element={<Navigate to="/1" replace mdxType="Navigate" />} mdxType="Route" />
      </Routes>
    </AnimationGroup>;
};

const layoutProps = {
  styles,
BaseLayout,
AnimatedRoutes
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Route change animation`}</h1>
<p>{`We used the `}<inlineCode parentName="p">{`element`}</inlineCode>{` prop from `}<inlineCode parentName="p">{`react-router-dom`}</inlineCode>{`'s `}<inlineCode parentName="p">{`Route`}</inlineCode>{` component, but only for illustrative purposes, this will work with any other way you structure your routes. You have to respect the following constraint however:`}</p>
<ul>
<li parentName="ul">
<p parentName="li">{`When having items come in and out (replacing the current content) then the `}<inlineCode parentName="p">{`AnimationGroup`}</inlineCode>{` will automatically set `}<inlineCode parentName="p">{`AnimatePresence`}</inlineCode>{` to `}<inlineCode parentName="p">{`mode="wait"`}</inlineCode>{`, which will `}<em parentName="p">{`wait`}</em>{` for the previously visible elements to disappear before animating new ones in. This `}<strong parentName="p">{`cannot work`}</strong>{` if there are more than 1 direct child of `}<inlineCode parentName="p">{`AnimationGroup`}</inlineCode>{`, this is a constraint from framer-motion.`}</p>
</li>
<li parentName="ul">
<p parentName="li">{`The way framer-motion recognises unmounting, the `}<inlineCode parentName="p">{`key`}</inlineCode>{` given to the direct child has to change when you want the animation to be triggered. This is why in the example below the `}<inlineCode parentName="p">{`Routes`}</inlineCode>{` has a `}<inlineCode parentName="p">{`key`}</inlineCode>{` equal to the current browser `}<inlineCode parentName="p">{`location`}</inlineCode>{`. This pattern can be applied to any child (e.g. in a gallery, each `}<inlineCode parentName="p">{`img`}</inlineCode>{` will have a `}<inlineCode parentName="p">{`key`}</inlineCode>{` equal to the currently active one, allowing the unmount animation to be triggered).`}</p>
</li>
<li parentName="ul">
<p parentName="li">{`As mentioned in the `}<inlineCode parentName="p">{`AnimationGroup`}</inlineCode>{` doc, when setting `}<inlineCode parentName="p">{`animateExit`}</inlineCode>{`, the prop will only propagate to the direct `}<inlineCode parentName="p">{`AnimatedItem`}</inlineCode>{`s, so any `}<inlineCode parentName="p">{`AnimatedItem`}</inlineCode>{` you want to animate when unmounting will need to have the `}<inlineCode parentName="p">{`animateExit`}</inlineCode>{` prop manually set, like in the example below.`}</p>
</li>
</ul>



<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Navbar />
<MemoryRouter>
  <AnimatedRoutes />
</MemoryRouter>
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;